import Adapter from '@ember-data/adapter';
import UUID from 'uuid-js';
import stockOrdersClient from '@catalog/shared/clients/stock-orders-client';
import { DeleteTransferOrderRequest, SearchTransferOrdersRequest, GetTransferOrdersRequest, UpdateTransferOrderRequest } from '@square/dashboard-protos/models/squareup/stockorders/message/transfer_orders';
import { NotFoundError } from '@ember-data/adapter/error';
import { hash } from 'rsvp';

/**
 * Methods return a chained hash to satisfy Adapter TS definitions
 */

export default class TransferOrder extends Adapter {
  findRecord(_store, _type, id, snapshot) {
    const {
      merchantToken
    } = snapshot.adapterOptions;
    return hash({
      response: stockOrdersClient.getTransferOrders(GetTransferOrdersRequest.create({
        merchantToken: merchantToken,
        transferOrderIds: [id]
      }))
    }).then(({
      response
    }) => {
      if (response.transferOrders.length === 0) {
        throw new NotFoundError();
      }
      return response.transferOrders[0];
    });
  }
  query(_store, _type, query) {
    return hash({
      response: stockOrdersClient.searchTransferOrders(SearchTransferOrdersRequest.create(query))
    }).then(({
      response
    }) => {
      const transferOrders = response.transferOrders;
      transferOrders.meta = {
        paginationToken: response.paginationToken
      };
      return transferOrders;
    });
  }
  updateRecord(store, _type, snapshot) {
    const {
      transferOrderLineUpdates,
      merchantToken
    } = snapshot.adapterOptions;

    // Include only changed attributes
    const transferOrderId = snapshot.id;
    const changedAttributes = snapshot.changedAttributes();
    const changedAttributesWithNewValues = Object.keys(changedAttributes).reduce((attrs, key) => {
      attrs[key] = changedAttributes[key]?.[1];
      return attrs;
    }, {});
    return hash({
      response: stockOrdersClient.updateTransferOrder(UpdateTransferOrderRequest.create({
        transferOrderId,
        merchantToken,
        idempotencyToken: UUID.create().toString(),
        transferOrderLineUpdates,
        ...changedAttributesWithNewValues,
        sourceUnitToken: changedAttributesWithNewValues.sourceLocation || undefined,
        destinationUnitToken: changedAttributesWithNewValues.destinationLocation || undefined
      }))
    }).then(({
      response
    }) => {
      // Update the transfer order lines in the store
      response.updatedLines?.forEach(line => {
        store.push(store.normalize('transfer-order-line', {
          ...line,
          transferOrderId
        }));
      });
      return response.updatedTransferOrder;
    });
  }
  deleteRecord(_store, _type, snapshot) {
    const {
      merchantToken
    } = snapshot.adapterOptions;
    return hash({
      response: stockOrdersClient.deleteTransferOrder(DeleteTransferOrderRequest.create({
        merchantToken: merchantToken,
        idempotencyToken: UUID.create().toString(),
        transferOrderId: snapshot.id
      }))
    }).then(({
      response
    }) => {
      return response;
    });
  }
}